

export default {
  props: {
    tabs: {
      type: Array,
      required: true,
      default: Array
    }
  },
  data () {
    return {
      activeTab: this.tabs[0],
      currentIndex: 0
    }
  },
  methods: {
    switchTab (tab, index) {
      if (this.currentIndex === index) { return false }
      this.currentIndex = index
      this.activeTab = tab
      this.$emit('activeTab', tab)
    },
    isActiveTab (tab) {
      return this.activeTab === tab
    },
    hoverClass (tab, index) {
      return this.isActiveTab(tab)
        ? 'bg-white shadow'
        : this.currentIndex < index ? '-translate-x-full' : 'translate-x-full'
    }
  }
}
